import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "react-emotion";
import {
  SelectOptions,
  CopyClipboard,
  QRCodeImage,
  Image,
  Input,
} from "components";
import { Button } from "appStyles";

import { makeStyles } from "@material-ui/core/styles";

import Tooltip from "@material-ui/core/Tooltip";
import HelpTwoToneIcon from "@material-ui/icons/HelpTwoTone";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const spanStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #858585;
  display: inline-block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  text-align: center;
  width: 80%;
`;

const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  margin-bottom: 35px;
  height: "100%";
  width: "100%";
  margin: 0;
`;

const FlexRow = css`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
`;

const Label = styled("label")`
  width: 220px;
  display: ${(props) => (props.title ? "block" : "none")};
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: inline-block;
`;

const LabelContainer = styled("div")`
  width: 220px;
  display: ${(props) => (props.title ? "block" : "none")};
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: inline-block;
`;

const col = css`
  flex: 0 0 92%;
`;

const image = css`
  height: 18em;
`;

const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 300,
    fontSize: "14px",
  },
}));

const landingPagePathText = `
This easy to remember URL is your app’s personalized website page on Mobile360, which contains a download link to your mobile app. Provide the link to customers for easy download.
`;

const qrCodeText = `Download the code and share with your customers as an easy way
for them to download your app.`;

const websiteText = `Premium Feature: Now, with Mobile360, your business can have an iOS app, Android app, AND a website. No extra work required. This premium add-on feature can be set up by contacting the Mobile360 team.`;

const ApplicationLayoutForm = ({
  application,
  updateNavType,
  updateLogoImage,
  updateLandingPagePath,
  notify,
}) => {
  const {
    view: {
      navigation: { type, navBarColor },
    },
    deeplinkUrl,
    name,
    logo,
    landingPagePath,
    websiteEnabled,
  } = application;
  // console.dir(application);

  // const {
  //   backgroundColor,
  //   backgroundImage,
  //   croppingAspectRatio,
  //   update,
  //   activeTemplate: { pageName }
  // } = props;
  const classes = useStyles();
  const update = (value) => {
    updateNavType(e.currentTarget.value);
  };

  const updateLogoImageHelper = (url) => {
    updateLogoImage(url);
  };

  const copy = () => {
    const text = "https://www.mobile360.app/" + landingPagePath;
    var input = document.createElement("input");
    input.setAttribute("value", text);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
    notify("copy");
    return result;
  };

  const options = [
    {
      value: "fullPage",
      label: "Full Page",
    },
    {
      value: "hamburger",
      label: "Hamburger",
    },
  ];
  const selectorStyle = {
    display: "inline-block",
  };
  const qrCodeName = `${name} Magic QR Code`;

  return (
    <div>
      <div className={row} style={{ marginBottom: "20px" }} width="470px">
        <div className={col}>
          <Label
            style={{
              marginRight: "10px",
              width: "197px",
            }}
          >
            Navigation Type{" "}
          </Label>
          <SelectOptions
            display="inline-block"
            width="15em"
            style={selectorStyle}
            setValue={updateNavType}
            options={options}
            value={type}
          />
        </div>
      </div>

      <Image
        options={{ croppingAspectRatio: "1.0" }}
        title="App Icon Upload"
        imageUrl={logo}
        uploadImage={updateLogoImageHelper}
        titleWidth={325}
      />
      {deeplinkUrl ? (
        <div className={row} style={{ marginTop: "15px" }}>
          {/* <div className={row + " " + FlexRow}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "45px",
              }}
            >
              <Label style={{ display: "inline-block", width: "auto" }}>
                App Download Link{" "}
              </Label>
              <Tooltip
                title={appDownloadText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              </Tooltip>
            </div>
            <CopyClipboard text={deeplinkUrl}></CopyClipboard>
          </div> */}

          <div className={row + " " + FlexRow}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Label style={{ display: "inline-block", width: "auto" }}>
                App Download QR Code{" "}
              </Label>
              <Tooltip
                title={qrCodeText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              </Tooltip>
            </div>

            <QRCodeImage
              text={deeplinkUrl}
              name={qrCodeName}
              logo={logo}
              navBarColor={navBarColor}
            />
          </div>
          <div className={col}>
            <div
              className={FlexRow}
              style={{
                marginBottom: "20px",
              }}
            >
              {" "}
              <span style={{ width: "135px" }}>App Download Link</span>
              <Tooltip
                title={landingPagePathText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginLeft: "5px", marginRight: "47px" }}
                />
              </Tooltip>
              <Label style={{ display: "inline-block", width: "205px" }}>
                https://www.mobile360.app/
              </Label>
              <Input
                width="180px"
                fontSize="1em"
                marginBottom="0px"
                field="Set Page Path"
                onChange={updateLandingPagePath("landingPagePath")}
                defaultValue={landingPagePath}
              />
              {document.queryCommandSupported("copy") && (
                <Button
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    textAlign: "center",
                    margin: "0px",
                    marginLeft: "20px",
                    height: "42px",
                    boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                  }}
                  className={mdcButton}
                  onClick={copy}
                >
                  <FileCopyIcon
                    style={{ marginRight: "5px" }}
                    className={"appLink"}
                  ></FileCopyIcon>
                  Copy
                </Button>
              )}
            </div>
          </div>
          <div className={row + " " + FlexRow} style={{ marginBottom: "15px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Label style={{ display: "inline-block", width: "auto" }}>
                Mobile360 Website{" "}
              </Label>
              <Tooltip
                title={websiteText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              </Tooltip>
            </div>
            <p style={{ marginLeft: "54px" }}>
              {websiteEnabled ? (
                <div>
                  <a
                    style={{
                      textDecoration: "none",
                      marginRight: "10px",
                      cursor: "default",
                      color: "black",
                    }}
                  >
                    Active
                  </a>
                  <a
                    style={{
                      textDecoration: "none",
                      color: "#89d2d3",
                      marginRight: "10px",
                    }}
                    href={landingPagePath + "/home"}
                    target="_blank"
                  >
                    Preview my Website
                  </a>
                </div>
              ) : (
                <div>
                  <a
                    style={{
                      textDecoration: "none",
                      marginRight: "10px",
                      cursor: "default",
                      color: "black",
                    }}
                  >
                    Inactive
                  </a>
                  <a
                    style={{
                      textDecoration: "none",
                      color: "#89d2d3",
                      marginRight: "10px",
                    }}
                    href={landingPagePath + "/home?isAdmin=true"}
                    target="_blank"
                  >
                    Preview my Website
                  </a>
                </div>
              )}
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

ApplicationLayoutForm.propTypes = {
  application: PropTypes.object,
  updateLandingPagePath: PropTypes.func,
  updateLogoImage: PropTypes.func,
};

export default ApplicationLayoutForm;
